import { useParams } from 'react-router';
import AppWrapper from '../../AppWrapper';
import { APP_TYPE } from '../../constants';
import { ManagerMenu } from '../../manager/managermenu';
import { GeodesistDetail } from '../../geodesists/components/GeodesistDetail';
import { useSelector } from '../../hooks';

import { Error, ERROR_TYPE } from '../components/Error';
const ManagerGeodesistDetailPage = () => {
  const { id } = useParams<{ id: string }>();
  const { manager, apps } = useSelector((state) => state.app.config);

  return (
    <>
      {apps?.manager && manager?.modules?.geodesists ? (
        <AppWrapper
          appType={APP_TYPE.MANAGER}
          menu={<ManagerMenu />}
          resource='Geodesists'
          action='list.view'
        >
          <GeodesistDetail geodesistId={id!} />
        </AppWrapper>
      ) : (
        <Error type={ERROR_TYPE.NOT_FOUND} />
      )}
    </>
  );
};

export default ManagerGeodesistDetailPage;
